// Utilities
import { defineStore } from 'pinia'
import { version as appVersion } from '../../package.json'

export const useAppStore = defineStore('app', {
  state: () => ({
    version       : appVersion,
    searchModel   : '',
    sortModel     : ['votes'],
    sortType      : 'desc',
    favoritesModel: false
  }),

  getters: {},

  actions: {},

  persist: {
    storage: sessionStorage,
    pick   : undefined,
    omit   : undefined
  }
})
